













import { computed, defineComponent, getCurrentInstance } from '@vue/composition-api';
import { BaseModal as BaseModalOriginal } from '@getaccept/lib-ui';
import Portal from './Portal.vue';

export default defineComponent({
  components: {
    BaseModalOriginal,
    Portal,
  },
  inheritAttrs: false,
  setup(_, { attrs }) {
    const allAttrs = computed(() => {
      const { staticClass, staticStyle } = getCurrentInstance().vnode.data;
      return { ...attrs, class: staticClass, style: staticStyle };
    });

    return { allAttrs };
  },
});
